import useScrollAnimation from "../../../hooks/useScrollAnimation";
import "../../../styles/scroll-animations.css";

const CTASection = () => {
    const [sectionRef, isVisible] = useScrollAnimation({ threshold: 0.3 });

    return (
        <div className="section pd-64px-tablet">
            <div 
                ref={sectionRef}
                data-w-id="ce8f1b71-831b-e457-3f5f-b7b866a37b82" 
                className={`cta-section scroll-animate scroll-blur-in ${isVisible ? 'visible' : ''}`}
            >
                <div className="container-default w-container">
                    <div data-w-id="ce8f1b71-831b-e457-3f5f-b7b866a37b84" className="inner-container _845px"
                         style={{
                             flexDirection: 'column',
                             display: 'flex',
                             alignItems: 'flex-start'
                         }}>
                        <div className="big-font-title display-2---size">Contact</div>
                        <h2 className="display-2 mg-bottom-32px" style={{textAlign: 'left'}}>Have an idea? <br/>Let's
                            get in touch</h2>
                        <a href="/contact"
                           className="btn-secondary w-button">Contact us</a>
                    </div>
                </div>
            </div>
        </div>
    )

}

export default CTASection
